import classNames from 'classnames';
import Image from 'next/image';

import styles from './AdditionalInformation.module.scss';

const AdditionalInformation = ({ items }) => {
  const renderItem = (item, key) => {
    return (
      <div
        className={`${styles.item} ${styles[items.type]}`}
        key={key}
        itemScope
        itemType='https://schema.org/Information'
      >
        <div className={classNames(['characteristics--image', styles.icon])}>
          <div className={styles.nameBlock}>
            <span className={styles.name}>{item?.text}</span>
          </div>
        </div>
        <div className={styles.value}>
          <span className={styles.right_text}>{item?.right_text}</span>
          {item?.price_icon && (
            <Image
              src={item?.price_icon}
              alt='price icon'
              title='Price icon'
              width={20}
              height={20}
              loading='lazy'
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.characteristics}>
      <div className={styles.containerTitle}>{items?.title}</div>
      <div className={styles.list}>{items?.sections?.map(renderItem)}</div>
    </div>
  );
};

export default AdditionalInformation;
